import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ApiIntegrationType } from '../../enums/ApiIntegrationType';
import {
    requestCreateIntegration,
    requestIntegrations,
    requestRegenerateIntegrationKey,
} from '../integrations/integrations';
import { IntegrationApiResponse } from '../integrations/types/IntegrationApiResponse';

export function useIntegrations() {
    return useQuery({
        queryKey: [`integrations`],
        queryFn: async ({ signal }): Promise<IntegrationApiResponse[]> => {
            const result = (await requestIntegrations(signal)).data;
            return result;
        },
    });
}

export function useRegenerateIntegrationKey() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (sourceId: ApiIntegrationType) =>
            (await requestRegenerateIntegrationKey(sourceId)).data,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['integrations'] });
        },
    });
}

export function useCreateIntegration() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (sourceId: ApiIntegrationType) =>
            (await requestCreateIntegration(sourceId)).data,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['integrations'] });
        },
    });
}
